import { connect } from 'react-redux';
import React from 'react';
import { Form } from 'antd';
import { KBButton, KBUserInput } from 'components';
import { SAFE_SETTING } from 'app/constants/hint';
import * as selectors from 'app/selectors';
import * as roleUtils from 'app/reducers/role';

const usersToValue = users =>
  users && users.length ? users.map(user => user.id).join(',') : '';
const getChangeValue = value => (value && value.target ? value.target.value : value);

function FormField({ children, error, onChange, onClearError, touched, value }) {
  return children({
    value,
    touched,
    error,
    onChange: nextValue => {
      onChange(getChangeValue(nextValue));
      onClearError();
    }
  });
}

const getInitialValues = props => ({
  user_ids: usersToValue(props.selectUsers)
});

function SpaceRoleRequiredUsersForm(props) {
  const { description, role, updateSpaceRole, users, selectUsers } = props;
  const [form] = Form.useForm();
  const [errors, setErrors] = React.useState({});
  const [submitting, setSubmitting] = React.useState(false);
  const initialValues = React.useMemo(() => getInitialValues(props), [props.selectUsers]);
  const initialValuesKey = JSON.stringify(initialValues);

  React.useEffect(() => {
    form.setFieldsValue(initialValues);
    setErrors({});
  }, [form, initialValuesKey]);

  const renderField = (name, render) => (
    <Form.Item name={name} noStyle>
      <FormField
        error={errors[name]}
        touched={!!errors[name]}
        onClearError={() => setErrors(prevErrors => Object.assign({}, prevErrors, { [name]: undefined }))}
      >
        {render}
      </FormField>
    </Form.Item>
  );

  const handleFinish = values => {
    if (!values.user_ids) {
      setErrors({ user_ids: '请至少选择一个员工' });
      return;
    }

    setSubmitting(true);
    const result = updateSpaceRole({
      role,
      user_ids: values.user_ids.split(',')
    });
    if (result && result.then) {
      return result.then(
        value => {
          setSubmitting(false);
          return value;
        },
        error => {
          setSubmitting(false);
          throw error;
        }
      );
    }
    setSubmitting(false);
    return result;
  };

  return (
    <Form form={form} initialValues={initialValues} onFinish={handleFinish}>
      <div className="kb-form-container" style={{ padding: 0 }}>
        {description ? <p style={{ marginBottom: 15 }}>{description}</p> : null}
        {renderField('user_ids', field => (
          <KBUserInput
            users={users}
            hint={SAFE_SETTING.manager}
            selectedUsers={selectUsers}
            multi={true}
            field={field}

          />
        ))}

        <div className="kb-row m-top">
          <KBButton className="certain-btn" type="button" submitting={submitting} onClick={() => form.submit()}>
            保存
          </KBButton>
        </div>
      </div>
    </Form>
  );
}

function mapStateToProps(state, props) {
  const { roles = [] } = props.setting || {};
  const userIds = roleUtils.getRoleUserByKey(roles, props.role);
  return {
    users: selectors.getSpaceUsers(state),
    selectUsers: selectors.getUsersByUserIds(state, userIds) || []
  };
}

export default connect(mapStateToProps)(SpaceRoleRequiredUsersForm);
